// UserDetail.js
import React, { useState, useEffect } from "react";
import axios from "axios";
import { Link, useLocation, useNavigate } from "react-router-dom";
import "../styles/UserDetail.css";
import NavBar from "./Navbar";
import TopNavBar from "./TopNavbar";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCalendarAlt } from "@fortawesome/free-solid-svg-icons";
import firebase from "firebase/compat/app";
import "firebase/compat/storage";
import { useAuth } from '../auth/auth';
import {
  deniedActionClass,
  usePermissionGuard,
} from "../hooks/usePermissionGuard";
import { PERMISSIONS, canCreatePayslip } from "../utils/rbac";
const apiUrl = process.env.REACT_APP_API_URL;

function UserDetail({ props }) {
  const [user, setUser] = useState({});
  const [invoices, setInvoices] = useState([]);
  const [imageURL, setImageURL] = useState("");
  //const userEmail = match.params.email;
  const location = useLocation();
  const navigate = useNavigate();
  const id = location.state;
  const { guardAction, PermissionDialog } = usePermissionGuard();
  //console.log("userDetails ", userEmail);
  useAuth();

  function formatInvoiceAdditions(additions) {
    const numericValue = Number(additions);

    if (isNaN(numericValue) || numericValue % 1 !== 0) {
      // Check if it's a decimal
      const formattedValue = numericValue.toFixed(2); // Ensure 2 digits after the decimal point
      return formattedValue;
    } else {
      // If it's an integer, add .00 to make it a decimal with 2 digits after the decimal point
      return additions + ".00";
    }
  }

  useEffect(() => {
    const fetchUserDetails = async () => {
      try {
        console.log("here running");
        console.log(id);
        console.log("here running");
        const response = await axios.post(
          `${apiUrl}/getEmployeeDetail`,
          {
            id: id, // Assuming userEmail is defined in your component state
          }
        );
        //console.log(response.data.data);
        setUser(response.data.data); // Set the state to response.data.data
        setImageURL(response.data.data.image);
        console.log("user ", user.name);
        console.log("response.data.data ", response.data.data);
        if (user && user.image) {
          const storageRef = firebase.storage().ref().child('employees');;
          const imageRef = storageRef.child(user.image);

          // Retrieve the download URL for the image
          const imageUrl = await imageRef.getDownloadURL();
          console.log("imageUrl ", imageUrl);
          //setImageURL(imageUrl); // Set the image URL in the component state
        }

        const invoiceResponse = await axios.post(
          `${apiUrl}/getUserInvoice`,
          {
            id: id, // Assuming userEmail is defined in your component state
          }
        );

        setInvoices(invoiceResponse.data.data);
      } catch (error) {
        console.error("Failed to fetch user details:", error);
      }
    };

    fetchUserDetails();
  }, [id]);

  return (
    <div>
      <NavBar />
      <TopNavBar />
      <PermissionDialog />
      <div className="user-detail-card">
        <div className="user-detail-main">
        <div className="admin-header">
              <div className="left-section">
                <h1 className="admin-card-title">
                  <span className="admin-card-title-span">Manage Employee</span>
                </h1>
              </div>
              
            </div>
          {user && Object.keys(user).length > 0 ? ( // Check if user and user[0] are defined
            <>
              <div className="user-detail-inner-div-profile">
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <div>
                    <h3 className="gold-text">Basic Details</h3>
                  </div>
                  <Link
                    to="/generateInvoice"
                    state={user.email}
                    className={`nav-link ${deniedActionClass(canCreatePayslip())} ${
                      location.pathname === "/generateInvoice"
                        ? "active-link"
                        : ""
                    }`}
                    onClick={(e) => {
                      e.preventDefault();
                      guardAction(PERMISSIONS.CREATE_PAYSLIP, "generate payslip", () => {
                        navigate("/generateInvoice", { state: user.email });
                      });
                    }}
                  >
                    <FontAwesomeIcon icon={faCalendarAlt} />
                    <span className="link-text">Generate Invoice</span>
                  </Link>
                </div>
                <div class="user-details-container">
                  <div class="user-basic-info">
                    <div>
                      <strong>Name:</strong> {user.name}
                    </div>
                    <div>
                      <strong>Email:</strong> {user.email}
                    </div>
                    <div>
                      <strong>Pay Rate:</strong> {user.age}
                    </div>
                  </div>
                  {imageURL && (
                    <div className="user-image-container">
                      <img src={imageURL} alt="User Image" />
                    </div>
                  )}
                </div>
              </div>

              <div className="user-detail-inner-div">
                <div>
                  <h3 className="gold-text">Invoice</h3>
                </div>
                <div className="invoice-table-wrapper">
                  <table className="invoice-table">
                    <thead>
                      <tr>
                        <th>S.no</th>
                        <th>Employee Id</th>
                        <th>Name</th>
                        <th>Pay Period(mm/dd)</th>
                        <th>Pay Rate($)</th>
                        <th>Hours</th>
                        <th>Additions</th>
                        <th>Deductions</th>
                        <th>Amount</th>
                        <th>YTD Amount</th>
                      </tr>
                    </thead>
                    <tbody>
                      {invoices.map((invoice, index) => (
                        <tr key={invoice.id}>
                          <td>{index + 1}</td>
                          <td>{invoice.userId}</td>
                          <td>{invoice.name}</td>
                          <td>{invoice.payPeriod}</td>
                          <td>{invoice.payRate}</td>
                          <td>{invoice.hours}</td>
                          <td>{invoice.Additions}</td>
                          <td>{invoice.Deductions}</td>
                          <td>{invoice.Amount}</td>
                          <td>{formatInvoiceAdditions(invoice.YTDFinal || invoice.YTDAmount)}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </>
          ) : (
            // Render a loading message or placeholder when data is not available yet
            <div>Loading...</div>
          )}
        </div>
      </div>
    </div>
  );
}

export default UserDetail;
